module.exports = __webpack_public_path__ + "static/media/21ECLAC24.70cb0ad7.jpg";